import React from 'react';
import Link from 'gatsby-link';
import imgCF from './jake.jpg';
import BackNav from '../components/BackNav';
import FooterRainbow from '../components/FooterRainbow';

// Feathr images
import imgFeathr1 from "../images/feathr/feathr-0.png";
import imgFeathr2 from "../images/feathr/feathr-1.jpg";
import imgFeathr3 from "../images/feathr/feathr-2.jpg";
import imgFeathr4 from "../images/feathr/feathr-3.jpg";
import imgFeathr5 from "../images/feathr/feathr-4.jpg";
import imgFeathr6 from "../images/feathr/feathr-5.jpg";
import imgFeathr7 from "../images/feathr/feathr-6.jpg";
import imgFeathr8 from "../images/feathr/feathr-7.jpg";
import imgFeathr9 from "../images/feathr/feathr-icon.jpg";
import imgFeathr10 from "../images/feathr/feathr-site-800.jpg";
import imgFeathr11 from "../images/feathr/feathr-web-1.jpg";
import imgFeathr12 from "../images/feathr/feathr-web-2.png";
import imgFeathr13 from "../images/feathr/feathr-web-3.png";
import imgFeathr14 from "../images/feathr/whiteboard.jpeg";

const Feathr = () =>
  <div>
    <div className="main work-page relative">
      <BackNav />
      <div className="row">
        <h1 className='huge-text col-sm-12'>Feathr</h1>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <p className="lead">Feathr began as a replacement to paper business cards. Do you remember what it' like to go to a conference, get a pocket full of business cards, and never end up making meaningful connections with most of those people? Feathr organized and made it easy to share your contact information simply.</p>
          <p className="lead">We ran into the classic 'chicken and egg' problem - but had great success sponsoring events - so we pivoted into the events space. We sponsored events and even spun out white-labeled conference apps. </p>
          <p className="lead">Designed apps for iOS, Android, inbound marketing website, admin dashboard, and all marketing and communications design. Led the product and team in all aspects of design.
          </p>
        </div>
      </div>
      <div className="col-sm-12">
        <img className="img-responsive" src={imgFeathr1} />
      </div>
      <div className="col-sm-12">
        <img className="img-responsive" src={imgFeathr2} />
      </div>
      <div className="col-sm-6">
        <img className="img-responsive" src={imgFeathr14} />
      </div>
      <div className="col-sm-6">
        <img className="img-responsive" src={imgFeathr7} />
      </div>
      <div className="col-sm-12">
        <img className="img-responsive" src={imgFeathr5} />
      </div>
      <div className="col-sm-12">
        <img className="img-responsive" src={imgFeathr9} />
      </div>

      <div className="col-sm-6">
        <img className="img-responsive" src={imgFeathr6} />
      </div>
      <div className="col-sm-6">
        <img className="img-responsive" src={imgFeathr7} />
      </div>
      <div className="col-sm-6">
        <img className="img-responsive" src={imgFeathr4} />
      </div>
      <div className="col-sm-6">
        <img className="img-responsive" src={imgFeathr8} />
      </div>

      <div className="col-sm-12">
        <h2> Website Redesign </h2>
        <p className="lead">
          Generated leads and explained the usefulness of the app for event atendees, organizers, and sponsors.
        </p>
      </div>
      <img className="img-responsive shadow" src={imgFeathr10} />
        <p className="lead">
        As the platform for events evolved, we needed a dashboard for organizers to create and edit events online:
        </p>
        <div className="col-sm-12">
          <img className="img-responsive" src={imgFeathr11} />
        </div>

      <div className="row">
        <div className="col-sm-6">
          <img className="img-responsive" src={imgFeathr12} />
        </div>
        <div className="col-sm-6">
          <img className="img-responsive" src={imgFeathr13} />
        </div>
      </div>
    </div>

    <FooterRainbow />
  </div>

export default Feathr



// WEBPACK FOOTER //
// ./src/pages/feathr.js